import $ from 'jquery';
import pageScripts from './pages';
import 'what-input';
import { Foundation } from 'foundation-sites';
import { Reveal } from 'foundation-sites/js/foundation.reveal';


$(document).foundation();

//Bind the checkbox field with the radios

$('input[name="exampleSwitch"]').on('click', function(){
    if ( $(this).is(':checked') ) {
        $('fieldset[name="carTypes"]').show();
    } 
    else {
        $('fieldset[name="carTypes"]').hide();
    }
});

$( document ).ready( function () {
	//Require all components here.
	require( './components/foundation' );

    //Menu toggle
    $(".menuBarToggle").click(function() {
        $(this).toggleClass('active');
        $(".menuBarPanel").toggleClass('open');
        $("body").toggleClass('noTouch')
    });

    $(".mobile-nav ul li.menu-item").click(function () { 
        $(".sub-menu").hide();
        $(this).find(".sub-menu").show();
    });
	
});

//Woo Quantity

$(function() {
    var timeout;
    $('.woocommerce').on('change', 'input.qty', function(){

		if ( timeout !== undefined ) {
			clearTimeout( timeout );
		}

		timeout = setTimeout(function() {
			$("[name='update_cart']").trigger("click");
		}, 1000 ); // 1 second delay, half a second (500) seems comfortable too
	});
});

//Owl carousel

$("#services-owl").owlCarousel({
    loop:true,
    margin:0,
    responsiveClass:true,
    mouseDrag: true,
    dots: false,
    nav: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut', 
    autoplayHoverPause:false,
    responsive:{
    0:{
        items:1,
    },
    600:{
        items:3,
    },
    1000:{
        items:4,
        loop:true
    }
}
});

//C02 Calculator

! function(t) {
	var e = {};

	function o(n) {
		if(e[n]) return e[n].exports;
		var r = e[n] = {
			i: n,
			l: !1,
			exports: {}
		};
		return t[n].call(r.exports, r, r.exports, o), r.l = !0, r.exports
	}
	o.m = t, o.c = e, o.d = function(t, e, n) {
		o.o(t, e) || Object.defineProperty(t, e, {
			configurable: !1,
			enumerable: !0,
			get: n
		})
	}, o.n = function(t) {
		var e = t && t.__esModule ? function() {
			return t.default
		} : function() {
			return t
		};
		return o.d(e, "a", e), e
	}, o.o = function(t, e) {
		return Object.prototype.hasOwnProperty.call(t, e)
	}, o.p = "", o(o.s = 2)
}({
	2: function(t, e, o) {
		o("Y1jE"), t.exports = o("8YM+")
	},
	"8YM+": function(t, e) {
		! function(t) {
			function e() {
				var e = t(document).height();
				t(".sidebarwrapper").height(e)
			}
			t(document).on("click", "[data-duplicate-row]", function(o) {
				o.preventDefault(), o.stopPropagation();
				var n = t(this),
					r = n.data("duplicate-row"),
					a = t(r).html();
				if(a) {
					var i = n.data("duplicate-row-target"),
						l = n.parent();
					i && (l = l.nearest(i));
					var c = 1 + (l.data("new-row-counter") || 0);
					l.data("new-row-counter", c);
					var s = "new-" + c;
					a = a.replace("{id}", s);
					var u = t(a).removeClass("ghost-row");
					l.append(u), u.trigger("bless"), e()
				} else console.error("Template not found with selector", r)
			}), t(document).on("click", "[data-remove-row]", function(o) {
				var n = t(this),
					r = n.data("remove-row"),
					a = n.parent();
				r && (a = n.closest(r).first()), a.remove(), e(), t(".rules").trigger("recalculate")
			}), t(document).on("bless", function(e) {
				e.stopPropagation(), t(e.target).find("input[data-complex-part], select[data-complex-part]").resolveComplexName()
			}), t.fn.resolveComplexName = function() {
				return console.log("resolving complex name"), this.each(function() {
					var e = t(this);
					if(e.is("input, select")) {
						var o = e.data("complex-part");
						e.parents("[data-complex-part]").each(function(e, n) {
							o = t(n).data("complex-part") + o
						}), e.attr("name", o)
					}
				}), this
			}, t.fn.nearest = function(e) {
				var o = !1;
				return this.parents().each(function() {
					if(!o) {
						var n = t(this).find(e);
						n.length > 0 && (o = n.first())
					}
				}), o
			}
		}(jQuery)
	},
	Y1jE: function(t, e) {
		! function(t) {
			function e(t) {
				for(var e in t)
					if(t.hasOwnProperty(e)) return !1;
				return !0
			}
			t(document).on("keydown", ".compensation-form", function(t) {
				13 == t.keyCode && t.preventDefault()
			}), t(document).on("change", '.toolrow select[name="transport"]', function() {
				var e = t(this).val(),
					o = t(this).parents(".toolrow"),
					n = t("#" + e).html();
				o.find(t(".toolrow__field--type")).empty().html(n), t(".rules").trigger("recalculate")
			}), t(document).on("change", '.toolrow select[name="compensationtype"]', function() {
				var e = t(this).val(),
					o = t(this).parents(".toolrow"),
					n = t("#" + e).html();
				o.attr("class", "toolrow toolrow--" + e);
				var r = o.find(t(".toolrow__wrapper")).empty().html(n);
				if("flight" == e) {
					console.log('flight = : ' +e);
					var a = t(".fieldgroup--airports").data("ajax"),
						i = t(".fieldgroup--airports").data("placeholder");
					r.find(".fieldgroup--airports select").select2({
						minimumInputLength: 1,
						cache: !0,
						placeholder: i,
						escapeMarkup: function(t) {
							return t
						},
						templateResult: function(e) {
							var o = t(".fieldgroup--airports").data("searching");
							if(e.loading) return o;
							return "<div class='airport-result'>" + e.city + " <span>(" + e.code + ")</span></div>"
						},
						templateSelection: function(t) {
							return t.code
						},
						dropdownAutoWidth: !0,
						ajax: {
							url: a,
							delay: 250,
							processResults: function(t) {
								return {
									results: t
								}
							}
						},
						language: {
							inputTooShort: function() {
								return i
							}
						}
					})
				}
				t(".rules").trigger("recalculate")
			}), t('.toolrow select[name="compensationtype"]').trigger("change"), t(document).on("select2:select", function(e) {
				var o = e.params.data;
				t(e.target).parents(".toolrow__field").data("airportdata", o), t(".rules").trigger("recalculate")
			}), t(document).on("change", '.toolrow select[name="type"]', function() {
				t(".rules").trigger("recalculate")
			}), t(document).on("change", '.toolrow input[name="amount"]', function() {
				t(".rules").trigger("recalculate")
			}), t(document).on("keyup", ".toolrow input", function() {
				t(".rules").trigger("recalculate")
			}), t(".rules").on("recalculate", function() {
				! function() {
					var o = t(".rules__footer").data("price"),
						n = t(".rules__footer .tonc02"),
						r = t(".rules__footer .js-price"),
						a = 0,
						i = 0;
					0 == t(".toolrow").length && t(".rules").removeClass("rules--filled");
					t(".toolrow--travel").each(function() {
						var e = t(this).find(t('select[name="type"]')).val(),
							n = t(this).find(t('input[name="kilometers"]')).val().replace(/,/g, "."),
							r = t(this).find(t('input[name="amount"]')).val();
						i = (a += e * n * r / 1e3) * o
					}), t(".toolrow--energy").each(function() {
						var e = t(this).find(t('select[name="type"]')).val(),
							n = t(this).find(t('input[name="amount"]')).val();
						i = (a += e * n / 1e3) * o
					}), t(".toolrow--flight").each(function() {
						var n, r, l, c, s, u, p, d = t(this).find(".toolrow__field--departure").data("airportdata"),
							f = t(this).find(".toolrow__field--destination").data("airportdata");
						if(!e(d) && !e(f)) {
							var m = (n = d.lat, r = d.lng, l = f.lat, c = f.lng, s = .017453292519943295, u = Math.cos, p = .5 - u((l - n) * s) / 2 + u(n * s) * u(l * s) * (1 - u((c - r) * s)) / 2, 12742 * Math.asin(Math.sqrt(p))),
								h = t(this).find(t('select[name="type"]')).val(),
								g = t(this).find(t('input[name="amount"]')).val(),
								v = window.flyEmissions[1];
							v = m < 700 ? window.flyEmissions[0] : m >= 700 && m < 2500 ? window.flyEmissions[1] : window.flyEmissions[2], i = (a += h * m * v * g / 1e3) * o, t(".donatefooter button").removeClass("btn--light-green"), t(".donatefooter button").addClass("btn--green")
						}
					}), 0 == a && (a = 0);
					n.text(a), r.text(i), t('.calculate-compensationform input[name="compensate_amount"]').val(a), t(".calculate-compensationform .btn span").text(a.toFixed(2) + " ton (€" + Math.ceil(a) * t(".rules__footer").data("price") + ")");
					n.text(a), r.text(i), t('.calculate-compensationform input[name="compensate_post_amount"]').val(i.toFixed(2));
				}()
			}), t(".rules .add_firstrow").on("click", function() {
				t(".rules").addClass("rules--filled")
			})
		}(jQuery)
	}
});


jQuery( function( $ ) {
	if ( ! String.prototype.getDecimals ) {
		String.prototype.getDecimals = function() {
			var num = this,
				match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
			if ( ! match ) {
				return 0;
			}
			return Math.max( 0, ( match[1] ? match[1].length : 0 ) - ( match[2] ? +match[2] : 0 ) );
		}
	}
	// Quantity "plus" and "minus" buttons
	$( document.body ).on( 'click', '.plus, .minus', function() {
		var $qty        = $( this ).closest( '.quantity' ).find( '.qty'),
			currentVal  = parseFloat( $qty.val() ),
			max         = parseFloat( $qty.attr( 'max' ) ),
			min         = parseFloat( $qty.attr( 'min' ) ),
			step        = $qty.attr( 'step' );

		// Format values
		if ( ! currentVal || currentVal === '' || currentVal === 'NaN' ) currentVal = 0;
		if ( max === '' || max === 'NaN' ) max = '';
		if ( min === '' || min === 'NaN' ) min = 0;
		if ( step === 'any' || step === '' || step === undefined || parseFloat( step ) === 'NaN' ) step = 1;

		// Change the value
		if ( $( this ).is( '.plus' ) ) {
			if ( max && ( currentVal >= max ) ) {
				$qty.val( max );
			} else {
				$qty.val( ( currentVal + parseFloat( step )).toFixed( step.getDecimals() ) );
			}
		} else {
			if ( min && ( currentVal <= min ) ) {
				$qty.val( min );
			} else if ( currentVal > 0 ) {
				$qty.val( ( currentVal - parseFloat( step )).toFixed( step.getDecimals() ) );
			}
		}
		// Trigger change event
		$qty.trigger( 'change' );
	});
});